import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IBIN } from "src/models/Prices/BIN.models";

interface BINState {
  bins: IBIN[];
  binToEdit: IBIN | null;
}

const initialState: BINState = {
  bins: [],
  binToEdit: null,
};

const BINSlice = createSlice({
  name: "BIN",
  initialState,
  reducers: {
    setBINList: (state, action: PayloadAction<IBIN[]>) => {
      state.bins = action.payload;
    },
    setBINToEdit: (state, action: PayloadAction<IBIN | null>) => {
      state.binToEdit = action.payload;
    },
    concatListBIN: (state: BINState, action: PayloadAction<IBIN[]>) => {
      state.bins = [...state.bins.concat(action.payload)];
    },
    addBIN: (state, action: PayloadAction<IBIN>) => {
      state.bins.push(action.payload);
    },
    updateBIN: (state, action: PayloadAction<IBIN>) => {
      let itemIndex = state.bins.findIndex(
        item => item.binId === action.payload.binId
      );
      if (itemIndex !== -1) state.bins[itemIndex] = action.payload;
    },
    deleteBIN: (state, action: PayloadAction<number>) => {
      const newArray = state.bins.filter(item => item.binId !== action.payload);
      state.bins = newArray;
    },
  },
});

export const {
  setBINList,
  concatListBIN,
  setBINToEdit,
  addBIN,
  updateBIN,
  deleteBIN,
} = BINSlice.actions;

export default BINSlice.reducer;
